import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'common/helpers'
import FormX from 'sb-formx'
import { email, required } from 'helpers/validation'
import resolveEndpoint from 'sb-request/util/resolveEndpoint'
import request from 'superagent'
import cx from 'classnames'
import { useReducerState, useCallback, useMedia } from 'sb-hooks'
import { injectIntl } from 'sb-react-intl'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Field from 'components/_new/forms/Field/Field'

import messages from './messages'
import s from './FooterCollectEmailForm.scss'


const form = new FormX({
  fields: {
    email: [ required, email ],
  },
})


const FooterCollectEmailForm = (props) => {
  const { isMobile } = useMedia()
  const [ state, setState ] = useReducerState({
    isFetching: false,
    isEmailCollected: false,
    isError: false,
  })

  const submit = useCallback((event) => {
    event.preventDefault()

    form.submit()
      .then(({ email }) => {
        setState({
          isFetching: true,
        })

        request.post(resolveEndpoint('rest/email/collect'))
          .send({ email })
          .then(() => {
            setState({
              isFetching: false,
              isEmailCollected: true,
            })

            form.unsetValues()
          })
          .catch(() => {
            setState({
              isFetching: false,
              isError: true,
            })
          })
      })
  }, [ setState ])

  const { isFetching, isEmailCollected, isError } = state
  const { intl, text, isHumble } = props

  const inputPlaceholder  = intl.formatMessage(messages.enterEmailAddress)
  const labelMessage      = intl.formatMessage(messages.label)
  const submitMessage     = intl.formatMessage(messages.submit)
  const defaultText       = isHumble ? messages.receiveSpecialOffers : messages.letsKeepInTouch

  const iconButtonClassName = cx({
    [s.whiteButton]: isHumble,
  })

  return (
    <Box
      pt={isMobile || isHumble ? null : '24'}
      pb={isMobile && !isHumble ? '24' : null}
    >
      <Text
        className={s.label}
        message={text || defaultText}
        color={isHumble ? 'white' : 'gray-50'}
        semibold={!isHumble}
      />
      <form noValidate onSubmit={submit}>
        {
          isEmailCollected || isError ? (
            <Box pt="16" pb="16">
              <Text
                message={isError ? messages.errorOccurred : messages.thanksForSubscribing}
                color={isError ? 'error' : 'white'}
              />
            </Box>
          ) : (
            <Box pt="12">
              <Field
                className={cx({ [s.input]: isHumble })}
                label={labelMessage}
                placeholder={inputPlaceholder}
                field={form.fields.email}
                autoComplete="email"
                loading={isFetching}
                icon={isHumble ? 'rightArrowSmall' : 'rightArrow'}
                standardView
                withBorder={false}
                iconColor={isHumble ? null : 'brand'}
                iconButtonProps={{
                  className: iconButtonClassName,
                  type: 'submit',
                  'aria-label': submitMessage,
                }}
              />
            </Box>
          )
        }
      </form>
    </Box>
  )
}

FooterCollectEmailForm.propTypes = {
  intl: PropTypes.object.isRequired, // @injectIntl
  text: PropTypes.object,
  isHumble: PropTypes.bool,
}


export default compose(
  injectIntl,
)(FooterCollectEmailForm)
